import { css } from '@emotion/react';
import { THEME } from '@anytag/shared-constants';
import { Carousel, PostModal } from '@anytag/shared-molecules';

interface PostInfoSectionProps {
  caption: string;
  images?: string[];
  postUrl?: string | null;
  postedDate?: string | null;
  influencer: React.ComponentProps<typeof PostModal.InfluencerInfo>['info'];
}

export const PostInfoSection = ({ caption, images, influencer, postUrl, postedDate }: PostInfoSectionProps) => (
  <>
    <div className="flex justify-between">
      <PostModal.InfluencerInfo info={influencer} />

      {postUrl || postedDate ? (
        <div className="flex flex-none flex-col items-end justify-center gap-1">
          <PostModal.SocialLink socialMedia="TIKTOK" postUrl={postUrl} />
          <PostModal.Date value={postedDate} />
        </div>
      ) : null}
    </div>
    {images?.length ? (
      <Carousel
        css={styles.carousel}
        sources={images}
        showIcon
        imageDownload={{ allowed: true, filename: `${influencer.name}_post_images_on_${postedDate}` }}
      />
    ) : null}
    <div css={styles.caption}>{caption}</div>
  </>
);

const styles = {
  caption: css({
    padding: '8px',
    height: '152px',
    overflow: 'auto',
    marginTop: '16px',
    boxSizing: 'border-box',
    border: THEME.border.base
  }),
  carousel: css({
    '--imageSize': '422px',
    width: '100%',
    marginTop: '24px',

    '.sliderImage': {
      height: 'var(--imageSize)',
      width: 'var(--imageSize)'
    }
  })
};
